<template>
  <ion-content fullscreen>
    <ion-grid>
      <ion-row>
        <ion-col>
          <h2 class="logo">Reset wachtwoord</h2>
        </ion-col>
      </ion-row>

      <form @submit.prevent="processForm">
        <ion-row class="ion-padding-top">
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-list lines="full" class="ion-no-margin ion-no-padding" v-if="state == 'reset'">
              <ion-item>
                <ion-label position="floating"
                  >E-mailadres
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input required type="email" @input="email = $event.target.value"></ion-input>
              </ion-item>
            </ion-list>

            <ion-list lines="full" class="ion-no-margin ion-no-padding" v-if="state == 'set'">
              <ion-text v-if="successMsg" class="succes-msg">{{ errorMsg }}</ion-text>
              <ion-text color="danger" v-if="errorMsg">{{ errorMsg }}</ion-text>
              <ion-item>
                <ion-label position="floating"
                  >Nieuw wachtwoord
                  <ion-text color="danger">*</ion-text>
                </ion-label>
                <ion-input
                  required
                  type="password"
                  @input="password = $event.target.value"
                ></ion-input>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row class="ion-padding-top">
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button
              expand="block"
              color="primary"
              type="submit"
              class="ion-no-margin"
              v-if="state == 'reset'"
              >Verstuur nieuw wachtwoord</ion-button
            >

            <ion-button
              expand="block"
              color="primary"
              type="submit"
              class="ion-no-margin"
              v-if="state == 'set'"
              >Bewaar nieuw wachtwoord</ion-button
            >
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
          >
            <ion-button expand="block" color="light" class="ion-no-margin" href="/register"
              >Maak een account</ion-button
            >
          </ion-col>
        </ion-row>

        <ion-row class="ion-padding-top">
          <ion-col
            size="10"
            offset="1"
            size-sm="10"
            offset-sm="1"
            size-md="8"
            offset-md="2"
            size-lg="6"
            offset-lg="3"
            size-xl="4"
            offset-xl="4"
            class="back"
          >
            <ion-anchor href="/login" router-direction="back"
              ><ion-icon name="md-arrow-back"></ion-icon
              ><span>Terug naar Aanmelden</span></ion-anchor
            >
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
  </ion-content>
</template>
<style lang="scss" scoped>
ion-item {
  --padding-start: 0;
}
.logo {
  font-family: "Eina", sans-serif;
  color: rgb(15, 22, 32);
  text-align: center;
  margin-top: 10vh;
  font-size: 24px;
  font-weight: 500;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

.back {
  display: flex;
  justify-content: center;

  ion-anchor {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    position: relative;

    span {
      margin-left: 20px;
    }
  }

  ion-icon {
    position: absolute;
    left: 0;
  }
}
</style>
<script>
import * as firebase from "firebase/app";

export default {
  name: "ForgotPassword",
  components: {},
  data() {
    return {
      email: "",
      password: "",
      errorMsg: "",
      successMsg: "",
      code: "",
      state: "reset"
    };
  },
  methods: {
    presentAlert() {
      let header = "Error";
      let message = this.errorMsg;
      if (this.successMsg != "") {
        message = this.successMsg;
        header = "Success";
      }

      return this.$ionic.alertController
        .create({
          header: header,
          message: message,
          buttons: ["OK"]
        })
        .then(a => a.present());
    },
    presentAlertConfirm() {
      let header = "Error";
      let message = this.errorMsg;
      if (this.successMsg != "") {
        message = this.successMsg;
        header = "Success";
      }

      return this.$ionic.alertController
        .create({
          header: header,
          message: message,
          buttons: [
            {
              text: "OK",
              handler: () => {
                console.log("Redirect");
                this.$router.push("/login");
              }
            }
          ]
        })
        .then(a => a.present());
    },
    processForm() {
      if (this.state == "reset") {
        this.sendResetEmail();
      } else if (this.state == "set") {
        this.setNewPassword();
      }
    },
    sendResetEmail() {
      let auth = firebase.auth();
      auth
        .sendPasswordResetEmail(this.email)
        .then(() => {
          // Email sent.
          this.errorMsg = "";
          this.successMsg = "Wachtwoord gereset, bekijk uw inbox";
          this.presentAlertConfirm();
          console.log("Reset Email Send");
        })
        .catch(error => {
          // An error happened.
          if (error.code === "auth/user-not-found") {
            this.errorMsg = "Kan wachtwoord niet resetten, email niet gevonden";
            this.presentAlert();
          }
          console.log("Error Reset Email Send");
        });
    },
    setNewPassword() {
      let auth = firebase.auth();
      auth
        .confirmPasswordReset(this.code, this.password)
        .then(() => {
          this.errorMsg = "";
          this.successMsg =
            "Nieuw wachtwoord is ingesteld, u wordt over enkele seconden naar het inlogscherm gebracht";
          this.presentAlert();
        })
        .catch(error => {
          if (error.code === "auth/invalid-action-code") {
            this.errorMsg = "Deze actie is ongeldig. Wellicht is de code verlopen.";
            this.presentAlert();
          }
        });
    },
    getState() {
      if (this.$route.query.mode === "resetPassword") {
        this.state = "set";
      } else {
        this.state = "reset";
      }
      this.code = this.$route.query.oobCode;
    }
  },
  created() {
    this.getState();
  }
};
</script>
